/*
 * <gw-wishlist-mount>
 *
 * Wraps a <gw-wishlist-button> (GammaWaves CDN element) and re-creates it from an inert
 * <template data-wishlist-template> on every connectedCallback, removing it on every
 * disconnectedCallback. This mirrors what the cart-drawer's section-render replace does
 * (fresh nodes, single fresh listener), but applies to *any* placement.
 *
 * Why: the upstream <gw-wishlist-button> has no disconnectedCallback cleanup and re-attaches
 * its click listener every connectedCallback. Prestige's Drawer/Modal moves itself to
 * document.body on show and back on hide (shouldAppendToBody === true), which disconnects
 * and reconnects every descendant. Without this wrapper, each open/close cycle stacks
 * another click listener on the heart, causing double/triple/N-fold click handling.
 * <product-rerender> on the PDP has the same effect on variant change.
 */
class GwWishlistMount extends HTMLElement {
  connectedCallback() {
    if (this.querySelector("gw-wishlist-button")) return;

    const tpl = this.querySelector("template[data-wishlist-template]");
    if (!tpl) return;

    this.appendChild(tpl.content.cloneNode(true));
  }

  disconnectedCallback() {
    for (const btn of this.querySelectorAll("gw-wishlist-button")) {
      btn.remove();
    }
  }
}

if (!customElements.get("gw-wishlist-mount")) {
  customElements.define("gw-wishlist-mount", GwWishlistMount);
}
